import apiEndpoint from '../../utils/apiEndpoint'
import AbstractApiClient from './AbstractApiClient'

const API_URL = import.meta.env.VITE_API_URL

class InventoryApi extends AbstractApiClient {

  getInventories(
    locationID: number,
    startDate: string,
    endDate: string,
    signal?: AbortSignal,
  ): Promise<GetInventoriesResponse> {

    return apiEndpoint({
      url: `${API_URL}/inventory/${locationID}?start=${startDate}&end=${endDate}`,
      method: 'get',
    }, signal)

  }

  getWindows(
    locationID: number,
    date: string,
    locationProductID?: number,
    signal?: AbortSignal,
  ): Promise<GetInventoryWindowsResponse> {

    let url = `${API_URL}/inventory/${locationID}/windows/${date}`

    if (locationProductID) {
      url = `${url}?locationProductID=${locationProductID}`
    }

    return apiEndpoint({
      url: url,
      method: 'get',
    }, signal)

  }

}

export default new InventoryApi()


export interface GetInventoriesResponse {
  inventory: GetInventoriesResponseInventory[]
  blackouts: {
    // TODO
  }
}

export interface GetInventoriesResponseInventory {
  ID: number
  blackoutIDs: number[]
  date: string // actually a datetime
  locationProductID: number
  spacesSold: number
  spacesSoldPerChannel: {[key: string]: number}
  spacesTotal: number
  event: null | {
    ID: number
    name: string
    venueID: number
    venueName: string
    start: string
    parkingStart: string
    end: string
    parkingEnd: string
  }
}

export interface GetInventoryWindowsResponse {
  windows: GetInventoryWindowsResponseWindow[]
  blackouts: {[key: number]: GetInventoryWindowsResponseBlackout}
  events: {[key: number]: GetInventoryWindowsResponseEvent}
}

export interface GetInventoryWindowsResponseWindow {
  start: string // datetime
  end: string // datetime
  spacesSold: number
  spacesTotal: number
  locationProducts: GetInventoryWindowsResponseLp[]
}

export interface GetInventoryWindowsResponseLp {
  locationProductID: number
  spacesSold: number
  spacesTotal: number
  spacesSoldPerChannel: {[key: string]: number}
  blackoutIDs: number[]
  eventIDs: number[]
}

export interface GetInventoryWindowsResponseBlackout {
  ID: number
  name: string
  locationID: number
  reason: string
  startDate: string
  endDate: string
  scope: string
  inventoryID: null | number
  locationProductID: null | number
  channels: string[]
}

export interface GetInventoryWindowsResponseEvent {
  ID: number
  name: string
  venueID: number
  venueName: string
  start: string
  end: string
  parkingStart: string
  parkingEnd: string
  spacesSold: number
}
